import { Alert, Box, Group, Text, ThemeIcon } from "@mantine/core"
import { IconChartLine } from "@tabler/icons-react"

type ForecastWarningAlertProps = {
  message: string
}

export function ForecastWarningAlert({ message }: ForecastWarningAlertProps) {
  return (
    <Box
      w="100%"
      style={{ minWidth: 0 }}
      mb={4}
      data-testid="forecast-warning-alert"
    >
      <Alert
        variant="light"
        color="warning"
        radius="sm"
        p="xs"
        icon={
          <ThemeIcon color="warning" variant="light" size="sm" radius="sm">
            <IconChartLine size={14} />
          </ThemeIcon>
        }
        styles={{
          root: {
            borderLeft: "3px solid",
            borderLeftColor: "var(--mantine-color-yellow)",
            width: "100%",
          },
          body: {
            gap: "var(--mantine-spacing-xs)",
          },
        }}
      >
        <Group gap={6} wrap="nowrap" style={{ minWidth: 0 }}>
          <Text size="xs" fw={600} c="warning" style={{ flexShrink: 0 }}>
            Forecast warning:
          </Text>
          <Text size="xs" c="warning" lineClamp={2} style={{ minWidth: 0 }}>
            {message}
          </Text>
        </Group>
      </Alert>
    </Box>
  )
}
